// extracted by mini-css-extract-plugin
module.exports = {"topMenus":"purchaseInvoice_topMenus__2f7Q2","menuItem":"purchaseInvoice_menuItem__y2bkd","active":"purchaseInvoice_active__3X3Na"};